var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8453 22C44.5598 23.2376 44.5598 24.7624 43.8453 26L35.6547 40.1865C34.9402 41.4241 33.6197 42.1865 32.1906 42.1865L15.8094 42.1865C14.3803 42.1865 13.0598 41.4241 12.3453 40.1865L4.1547 26C3.44017 24.7624 3.44017 23.2376 4.1547 22L12.3453 7.81347C13.0598 6.57586 14.3803 5.81347 15.8094 5.81347L32.1906 5.81347C33.6197 5.81347 34.9402 6.57586 35.6547 7.81347L43.8453 22Z",
    fill: "#7637FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 16H16.8C15.8059 16 15 16.7675 15 17.7143V26.2857C15 27.2325 15.8059 28 16.8 28H31.2C32.1941 28 33 27.2325 33 26.2857V17.7143C33 16.7675 32.1941 16 31.2 16Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 32H28",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28V32",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23.5793V20.7662C22 19.9889 22.848 19.5088 23.5145 19.9087L25.6785 21.2071C26.2995 21.5797 26.3308 22.4685 25.7374 22.8838L23.5735 24.3986C22.9107 24.8625 22 24.3884 22 23.5793Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.31aab4d7f1d298431eab70bf66127ee8.svg";
export { ForwardRef as ReactComponent };